import { Button } from "@mui/material"
import { store } from "../../../../stores/Store"
import MergeReview from "./MergeReview"
import { Alert } from "../../../.."
import Ajax from "../../../../Ajax"


export default function Merge ({
    dataSources,
    onCancel = () => {},
    onSubmit = (data) => {}
}) {

    const merge = async () => {

        var data: any = {}
        var reversedDataSources = [...dataSources].reverse()

        reversedDataSources.forEach((dataSource) => {
            data = {...data, ...dataSource}
        })

        data = {...data, ...store.QuestionnaireStore.mergeOverride}
        onSubmit(data)
    }

    return (
        <div className="form">

            <MergeReview dataSources={dataSources} />

            <div className="header">
                <Button
                    className="btn btn-sm"
                    onClick={() => onCancel()}>
                    Back
                </Button>

                <Button
                    color="success"
                    variant="contained"
                    className="btn btn-sm"
                    onClick={() => merge()}>
                    Continue using this data
                </Button>
            </div>
        </div>
    )
}